

import React, { useRef } from 'react';
import { Suspense } from 'react'
import { motion } from 'motion/react';
import AppLoader from '../../components/AppLoader/AppLoader';
const HomeApp = React.lazy(() => import('./HomeApp'));


const HomePage = () => {

  return (
    <>
      <Suspense fallback={<motion.div initial={{opacity:1}} animate={{transition:{duration:2}}} exit={{opacity:0}} className='h-[100vh] bg-black flex items-center justify-center '>
        {/* <h1 className='animate-pulse font-logo text-neutral-100 text-6xl'>Loading ...</h1> */}
        <AppLoader text="Loading Please wait ! ... "/>

        </motion.div>}>
        <HomeApp />
      </Suspense>
    </>

  );
};









export default HomePage;